import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { AdminCohortCoach } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

const { institutionAdmin } = appStrings.modules.coachingDashboard;

export const cohortCoachLabel = (coach: AdminCohortCoach): string => {
  const name = [coach.firstName, coach.lastName]
    .filter((part): part is string => part !== null)
    .join(' ');

  return name === '' ? institutionAdmin.unnamedCoach(coach.id) : name;
};

export const cohortCoachInitial = (coach: AdminCohortCoach): string =>
  cohortCoachLabel(coach).charAt(0);

/**
 * The badge resolves a missing name to a label carrying no id. Passing the roster-admin
 * label in the first half overrides that, so these surfaces keep the id-bearing label.
 */
export const cohortCoachBadgeName = (
  coach: AdminCohortCoach,
): Readonly<{ firstName: string; lastName: string }> =>
  coach.firstName === null && coach.lastName === null
    ? { firstName: cohortCoachLabel(coach), lastName: '' }
    : { firstName: coach.firstName ?? '', lastName: coach.lastName ?? '' };
